import { ref, watchEffect } from "vue";

// firebase imports
import { db } from "../firebase/config";
import {
  collection,
  onSnapshot,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";

const getCollection = (c, ob, l) => {
  const documents = ref(null);

  // collection reference
  let colRef = collection(db, c);

  if (l && ob) {
    colRef = query(colRef, orderBy(ob, "desc"), limit(l));
  }

  const unsub = onSnapshot(colRef, (snapshot) => {
    let results = [];
    snapshot.docs.forEach((doc) => {
      results.push({ ...doc.data(), id: doc.id });
    });

    // update values
    documents.value = results;
  });

  watchEffect((onInvalidate) => {
    onInvalidate(() => unsub());
  });

  console.log("👚 Pobrano documments...");
  return { documents };
};

export default getCollection;
